import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'


function Main() {


    const ImageData = [

        { video: "https://youtu.be/NbEBh8pt5jM" }
    ]

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Open House" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content fs-6">

                        <Row>


                            <Col md={12} className='c-right c-lineheight2dot5 text-dark'>
                                <div>
                                    <h3 className='c-headline mb-3'>Open House - An Interactive Session for Prospective Students 2024 </h3>
                                    <p className="caboutus">JEE Advanced 2024 qualified candidates (and their families) are invited to an OPEN HOUSE organized by IIT Tirupati on 16th June 2024 (Sunday). The candidates can get an overview of the Academic Programmes, Campus Development and Student Life at IIT Tirupati.
                                        The session mainly emphasizes on the Institute’s undergraduate curriculum, including dual degrees, policy for branch change, hostel infrastructure, health facilities and other student-centric information. </p>
                                    <p className="caboutus">The students can attend this session either in-person or online. The students intending to participate in the open house are requested to register at: 
                                        <Link className='c-link' to="https://forms.gle/8kDBqoWcTDGaBCNJ9" target="_blank" > https://forms.gle/8kDBqoWcTDGaBCNJ9</Link>
                                        </p>

                                    <p className="caboutus">To know more about the campus, visit:<Link className='c-link' to="https://www.youtube.com/watch?v=V0iNMuPV9Z8&t=1s" target="_blank" > https://www.youtube.com/watch?v=V0iNMuPV9Z8&t=1s</Link> </p>
                                </div>
                                <div>
                                    <h3 className='c-headline mt-5 mb-3'>Schedule & Brochure</h3>                                    

                                    <ul className='ms-3 c-lineheight2dot5 iarrow' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /><b>Date</b> &nbsp;:&nbsp; <b className="glowing-text" style={{ color: "maroon" }}>June 16th, 2024 (SUNDAY)</b></li>
                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /><b>10:00 AM</b> &nbsp;:&nbsp; <b className="glowing-text" style={{ color: "maroon" }}>Interactive session with The Director, Deans, HoDs, and the Student Representatives</b></li>
                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /><b>11:30 AM</b>  &nbsp;:&nbsp; <b className="glowing-text" style={{ color: "maroon" }}>Campus Tour</b></li>
                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /><b>Program Brochure</b>&nbsp;:&nbsp; <Link to="https://files.iittp.ac.in/pdfs/open/Open_House_2024.pdf" target="_blank" rel="noopener noreferrer" >
                                       <b className="glowing-text" style={{ color: "maroon" }}> Click here</b> </Link></li>
                                    </ul>
                                    <h3 className='c-headline mt-5 mb-3'>To attend in-person:</h3>
                                    <ul className='ms-3 c-lineheight2dot5 iarrow' >
                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /><b>Venue</b>&nbsp;:&nbsp;<b className="glowing-text" style={{ color: "maroon" }}>Lecture Hall Complex (LHC)</b> &nbsp;-&nbsp; <Link to="https://maps.app.goo.gl/wy1ajX1wZ85e2fMt5" target="_blank" rel="noopener noreferrer" >
                                        <b className="glowing-text" style={{ color: "maroon" }}>Click here to view google map</b> </Link></li>
                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /><b>To register </b>&nbsp;:&nbsp; <Link to="https://forms.gle/8kDBqoWcTDGaBCNJ9" target="_blank" rel="noopener noreferrer" >
                                        <b className="glowing-text" style={{ color: "maroon" }}>Click here </b> </Link></li>
                                        
                                    </ul>
                                    <h3 className='c-headline mt-5 mb-3'>To attend online:</h3>
                                    <ul className='ms-3 c-lineheight2dot5 iarrow' >
                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /><b>Join Zoom Session</b>&nbsp;:&nbsp;<b className="glowing-text" style={{ color: "maroon" }}>Zoom on June 16th, 2024 (SUNDAY) at 10:00 AM.</b>&nbsp; - &nbsp;<Link to="https://zoom.us/j/93635533894?pwd=e73hNE2fcMAamPpXJByxaGLBpawuYh.1" target="_blank" rel="noopener noreferrer" >
                                        <b className="glowing-text" style={{ color: "maroon" }}>Click here to Join Zoom Meeting</b> </Link></li>
                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /><b>To register </b>&nbsp;:&nbsp; <Link to="https://forms.gle/8kDBqoWcTDGaBCNJ9" target="_blank" rel="noopener noreferrer" >
                                        <b className="glowing-text" style={{ color: "maroon" }}>Click here </b> </Link></li>
                                        
                                    </ul>
                                </div>

                                <div>
                                   {/* <h3 className='c-headline mt-5 mb-3'>Join Session - Zoom on June 16th, 2024 (SUNDAY) at 10:00 AM.</h3>

                                    <ul className='ms-3 c-lineheight2dot5 iarrow' >

                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Zoom Link : <Link to="https://zoom.us/j/93635533894?pwd=e73hNE2fcMAamPpXJByxaGLBpawuYh.1" target="_blank" rel="noopener noreferrer">&nbsp;&nbsp; 
                                        <b>https://zoom.us/j/93635533894?pwd=e73hNE2fcMAamPpXJByxaGLBpawuYh.1</b> </Link></li>
                                    </ul>*/}

                                </div>

                                <h3 className='c-headline mt-5 mb-3'>To watch live streaming on Youtube: </h3>
                                <div className="grid col3 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                    {ImageData.map((item, Index) => (
                                        <div className="grid-item financial col-3 mt-3" key={Index}>
                                            
                                            <div>
                                            <iframe style={{ width: '800px' }}
                                                    height="500"
                                                    src="https://www.youtube.com/embed/9JbCFAb3TLI?si=T8c9VQCGhGgUzcju" 
                                                    title="YouTube video player" 
                                                    frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                              {/*  <iframe
                                                    style={{ width: '800px' }}
                                                    height="500"
                                                    src="https://www.youtube.com/live/cFwLnG0RixY"
                                                    title="YouTube video player"
                                                    frameBorder="0"
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                    allowFullScreen
                                    ></iframe>*/}
                                            </div>



                                               

                                            
                                        </div>
                                    ))}
                                </div>
                            </Col>
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;